export default "__VITE_ASSET__Cp_EJDCG__"